import { AuthedPage, HeaderFooterLayout } from '../app';

const Dashboard = ({ children }: { children: React.ReactElement }) => {
  return (
    <AuthedPage>
      <HeaderFooterLayout useDashboardHeader>
        <div className='mb-20 mt-1.5 max-w-[1440px] mx-auto'>{children}</div>
      </HeaderFooterLayout>
    </AuthedPage>
  );
};

export default Dashboard;
